export enum ProgramCategory {
  Foundation = 'Foundation',
  Attributes = 'Attributes',
  Application = 'Application',
  MemberResources = 'MemberResources',
  Supplemental = 'Supplemental',
  Course = 'Course',
  Legacy = 'Legacy',
}

export type ProgramScheduleType = {
  mon: boolean;
  tue: boolean;
  wed: boolean;
  thu: boolean;
  fri: boolean;
  sat: boolean;
  sun: boolean;
};

export type SessionDurationsType = {
  [key: string]: boolean;
};

export type ChallengeSession = {
  id: number;
  name: string;
  picture: string;
  description: string;
  challengeOrder: number;
  durationOptions: Record<string, boolean>;
};

export type Program = {
  id: number;
  name: string;
  picture: string;
  description: string;
  equipment: number;
  isDefault: boolean;
  complexity: number;
  bullets: string[];
  isExternal: boolean;
  externalLink: string | null;
  isAlphaPosse: boolean;
  category: ProgramCategory | null;
  programComplete: boolean;
  nextSession: Session | null;
  lastSession: Session | null;
  nextTrackSessionId: number | null;
  schedule: ProgramScheduleType;
  basicSessionCount: number;
  challengeSessionCount: number;
  challengeSessionAvailable: boolean;
  challengeSession: ChallengeSession | null;
  sessionsCount: number;
  completedSessionsCount: number;
  createdAt: string;
  sessions: Session[];
  programTrack: ProgramTrack;
};

export type Workout = {
  id: number;
  completedAt: string | null;
  workoutSurvey: string | null;
  preparationPhaseAnswer: number;
  completedPhases: number[];
  startedAt: string;
  timeLength: number;
  updatedAt: string;
};

export type Session = {
  workout: any;
  id: number;
  order: number;
  name: string;
  description: string;
  bullets: string[];
  picture: string;
  isBasic: boolean;
  challengeOrder?: number | null;
  durationOptions: SessionDurationsType;
  workouts: Workout[];
  lastSession: Workout;
  nextSession: Workout;
  session: {
    id: number;
    isBasic: false;
    bullets: string[];
    picture: string;
    name: string;
    durationOptions: {
      [key: string]: boolean;
    };
    description: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type ProgramTrackSession = {
  id: number;
  order: number;
  session: Session;
};

type ProgramTrack = {
  id: number;
  type: string;
  internalName: string;
  programTrackSessions: ProgramTrackSession[];
  sessionsCount: number;
  loopBackToTrackSessionId: number | null;
};

export type ProgramsSource = {
  total: number;
  limit: number;
  offset: number;
  userPrograms: {
    id: number;
    schedule: ProgramScheduleType;
    programTrack: ProgramTrack;
    nextSession: Session;
    lastSession: Session;
    nextTrackSessionId: number | null;
    programComplete: false;
    program: Omit<Program, 'schedule'>;
    completedSessionsCount: number;
  }[];
};

export interface ProgramsState {
  total: number;
  all: Program[];
  error?: string | null;
  loading?: boolean;
}
